module.exports = __webpack_public_path__ + "static/media/alexanderRust.e32cf90a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/alexanderRust.jpg
// module id = 1661
// module chunks = 1